import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { fetchAccess } from "../store/actions/accessActions"
import {
	fetchDepACompleterCount,
	fetchEmployes,
} from "../store/actions/depannageActions"
import {
	fetchAutreEntites,
	fetchFournisseurs,
	fetchMarques,
	fetchMoyenPaiements,
} from "../store/actions/autreActions"
import { fetchEntretiensSemaine } from "../store/actions/entretienActions"
import { fetchStockNonDebiteCount } from "../store/actions/atelierInventaireActions"
import { fetchPointsInterets } from "../store/actions/pointInteretActions"

// Préchargement des données globales de la session. Auparavant dans le useEffect
// de la barre de nav (couplage god-effect) ; monté ici une seule fois au niveau
// App. Ne lance les fetch que lorsque l'utilisateur est authentifié, et se
// re-déclenche à une nouvelle authentification.
//
// ⚠️ Critère d'appartenance à cette liste (audit 30.07.2026) : une donnée n'a sa
// place ici QUE si au moins un composant la LIT sans la charger lui-même. Tout
// ce qui est rechargé à l'ouverture de son écran doit partir — sinon on paie un
// appel HTTP à chaque connexion pour rien, et on déclenche des 403 chez les
// profils qui n'ont pas le module (cf. matrice de droits).
//
// Retirés le 30.07.2026, avec la raison :
//   - fetchAtelierModeles   → AtelierV2 le charge au clic « Appliquer un
//                             modèle », AtelierModeleListV2 et EntretienV2 au
//                             mount. (C'est aussi ce qui provoquait un 403 chez
//                             les employés depuis le gating de api/ateliermodeles.)
//   - fetchInventaireLimitChecker / fetchInventaireConsommables
//                           → lus uniquement par atelier/inventaire/*, qui les
//                             recharge (mount / ouverture de l'onglet).
//   - checkLocationsLate    → `lateLocs` n'est lu que par LocationGererV2, qui
//                             le dispatche à son montage.
//   - fetchParcColor        → `parcInfo.redVehicules` n'est lu par AUCUN
//                             composant : appel purement mort.
//   - fetchAdresses         → seul lecteur `AdresseContainer`, lui-même importé
//                             nulle part ; les écrans V2 utilisent
//                             `fetchAdressesV2` (recherche serveur à la frappe).
//
// Ce qui reste est porteur — chacun est lu par au moins un écran qui ne le
// charge pas : masterEntite/garages/polices/groups (NavV2, Configuration),
// employés (ModalHeures, pages de résultats, NavV2), badge « entretiens en
// retard » de la nav, fournisseurs (résolution du sous-traitant dans AtelierV2),
// marques (AtelierV2, DepMissionV2, EntiteFicheV2), moyens de paiement
// (TransactionV2, LocationV2, AtelierRestiDepModalV2), points d'intérêt
// (PointInteretSelectV2 du formulaire de mission).
//
// TODO : conditionner ces fetchs aux droits de l'utilisateur (il faudra chaîner
// sur la réponse d'`api/access`, qui n'est pas encore arrivée à ce moment-là).
// Laissés inconditionnels pour l'instant — aucun de ces endpoints n'est gaté.
export const useAppBootstrap = (isAuthenticated) => {
	const dispatch = useDispatch()
	useEffect(() => {
		if (!isAuthenticated) return
		// En premier : la map de droits gouverne les routes et la nav.
		dispatch(fetchAccess())
		dispatch(fetchAutreEntites())
		dispatch(fetchEmployes())
		dispatch(fetchEntretiensSemaine())
		dispatch(fetchStockNonDebiteCount())
		dispatch(fetchDepACompleterCount())
		dispatch(fetchFournisseurs())
		dispatch(fetchMarques())
		dispatch(fetchMoyenPaiements())
		dispatch(fetchPointsInterets())
	}, [dispatch, isAuthenticated])
}
